import medicineLoadError from "./medicine-load-error/MedicineLoadError.vue";
import medicineList from "./medicine-list/MedicineList.vue";
import vademecumService from "../../services/vademecum/Vademecum.js";
import { StorageService } from "../../services/StorageService.js";
import i18n from '../../i18n/index';

export default {
    components: { medicineLoadError, medicineList },
    data: () => ({

        newLoad: false,
        hideList: false,
        uploads: [],
        upload: { fileLoadDetails: [] },
        attachment: { name: "" },
        user: {},
        loading: false,
        overlay: false


    }),

    methods: {
        handleFilePondInit: function () {
            // FilePond instance methods are available on `this.$refs.pond`
            /* eslint-disable */
            console.log('FilePond has initialized');
        },

        handleUpload(upload) {
            this.upload = upload;
            this.hideList = true;
        },
        closeUpload() {
            this.newLoad = false;
            this.hideList = false;
            this.upload = { fileLoadDetails: [] };
            this.attachment = { name: "" };
            this.$refs.medicineList.getFileLog();
        },
        openFileChooser() {
            this.$refs.file.click();
        },

        handleFile() {
            this.loading = true;
            this.attachment = this.$refs.file.files[0];
            if (!this.attachment.length) { }
            vademecumService.uploadVademecum(this.attachment).then(response => {

                if (response.status == 200) {
                    this.closeUpload();
                    this.$refs.medicineList.getFileLog();
                }
                this.$notify({
                    group: "app",
                    type: "success",
                    text: i18n.t('processing-the-file')
                });
                this.loading = false;
                this.$refs.medicineList.getFileLog();
            })
                .catch(error => {
                    console.log('error', error.response);
                    this.loading = false;
                })
        },
        getUserName() {
            const user = StorageService.getUserData();
            this.user = user.id;
        },
        timer() {
            setTimeout(function () {
                this.loading = true
            }.bind(this), 3000);
        }
    }
};